<!--  -->
<template>
    <div class="business-content-main financialStatistics">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name" style="color: #303133">年度收入：</div>
                <div class="search-name" style="color: #303133; margin-left: 0px; font-weight: bold; font-size: medium">￥{{ incomeData.yearIncome }}</div>
                <div class="search-name" style="color: #303133">本月总收入：</div>
                <div class="search-name" style="margin-left: 0px; font-weight: bold; font-size: medium; color: green">￥{{ incomeData.currentMonthIncome }}</div>
                <div class="search-name" style="color: #303133">本月总支出：</div>
                <div class="search-name" style="margin-left: 0px; font-weight: bold; font-size: medium; color: red">￥{{ incomeData.currentMonthExpenses }}</div>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">时间</div>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :picker-options="startDateOps"
                    class="search-item"
                    size="small"
                    v-model="searchData.sDate"
                    type="date"
                    placeholder="开始日期"
                ></el-date-picker>
                <div class="search-name">&nbsp;-&nbsp;</div>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :picker-options="endDateOps"
                    class="search-item"
                    size="small"
                    v-model="searchData.eDate"
                    type="date"
                    placeholder="结束日期"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getIncomeMain">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <el-card class="box-card">
            <div class="incomeMainTitle">{{ incomeMainTitle }}</div>
            <div class="data-count">
                <div class="data-item">
                    <p>销售订单数</p>
                    <p>{{ incomeMain.salesOrdersCount }}</p>
                </div>
                <div class="data-item">
                    <p>采购订单数</p>
                    <p>{{ incomeMain.purchaseOrdersCount }}</p>
                </div>
                <div class="data-item">
                    <p>销售退单数</p>
                    <p>{{ incomeMain.salesReturnOrders }}</p>
                </div>
                <div class="data-item">
                    <p>销售总额</p>
                    <p>￥{{ incomeMain.salesSum }}</p>
                </div>
                <div class="data-item">
                    <p>采购总额</p>
                    <p>￥{{ incomeMain.purchaseSum }}</p>
                </div>
                <div class="data-item">
                    <p>销售退款总额</p>
                    <p>￥{{ incomeMain.salesReturnSum }}</p>
                </div>
                <div class="data-item">
                    <p>采购退款总额</p>
                    <p>￥{{ incomeMain.purchaseReturnSum }}</p>
                </div>
                <div class="data-item">
                    <p>销售出库总额</p>
                    <p>￥{{ incomeMain.salesOutSum }}</p>
                </div>
                <div class="data-item">
                    <p>采购入库总额</p>
                    <p>￥{{ incomeMain.purchaseInSum }}</p>
                </div>
                <div class="data-item">
                    <p>销售退货入库总额</p>
                    <p>￥{{ incomeMain.salesReturnInSum }}</p>
                </div>
                <div class="data-item">
                    <p>采购退货出库总额</p>
                    <p>￥{{ incomeMain.purchaseReturnOutSum }}</p>
                </div>
                <!-- <div class="data-item border-right-none">
          <p>商品总销售量</p>
          <p>{{incomeMain.SalesGoodsCount}}</p>
        </div> -->
            </div>
        </el-card>
        <div class="echart-ctn" id="echartCtn"></div>
        <div class="toggle-year">
            <span>年份：</span>
            <el-date-picker value-format="yyyy" size="small" v-model="searchYearData.Year" type="year" placeholder="选择年"></el-date-picker>
            <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="searchYear">查询</el-button>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    components: {
        breadcrumb
    },
    name: '',
    data() {
        return {
            incomeMainTitle: '上月数据',
            timeVisible: false,
            permission: {},
            incomeData: {},
            incomeMain: {},
            searchYearData: {
                Year: ''
            },
            searchData: {
                sDate: '',
                eDate: ''
            },
            date: [],
            series: [],
            startDateOps: {
                disabledDate: time => {
                    if (this.searchData.eDate) {
                        return time.getTime() > new Date(this.searchData.eDate);
                    }
                }
            },
            endDateOps: {
                disabledDate: time => {
                    if (this.searchData.sDate) {
                        return time.getTime() <= new Date(this.$util.getOtherDay(this.searchData.sDate, -1));
                    }
                }
            }
        };
    },
    mounted() {
        this.getIncomeData();
        this.getIncomeMain();
        let fullPath = this.$route.fullPath;
        document.onkeydown = event => {
            let isDialog = document.querySelector('.v-modal');
            let layui = document.querySelectorAll('.layui-layer');
            if (fullPath == this.$route.fullPath && !isDialog && layui.length <= 1) {
                if (event && event.keyCode == 13) {
                    this.getIncomeData();
                    this.getIncomeMain();
                }
            }
        };
        this.permission = this.$util.getPermission('Withdraw');
        this.getBeforeMonth();
        this.getBeforeYear();
        this.getYearIncomeExpenseStatistics();
    },
    methods: {
        searchYear() {
            this.getYearIncomeExpenseStatistics();
        },
        resetSearch() {
            this.searchData = {
                sDate: '',
                eDate: ''
            };
        },
        // 获取上个月月份
        getBeforeMonth() {
            let date = new Date();
            return date.getFullYear() + '-' + (date.getMonth() - 1);
        },
        getBeforeYear() {
            let date = new Date();
            this.searchYearData.Year = date.getFullYear().toString();
        },
        // 年度收入支出统计
        getYearIncomeExpenseStatistics() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/YearIncomeExpenseStatistics',
                    data: this.searchYearData
                })
                .then(res => {
                    this.date = ['1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份', '8月份', '9月份', '10月份', '11月份', '12' + '月份'];
                    let _series = [];
                    let data = res.data;
                    for (let i = 0; i < data.length; i++) {
                        _series.push({
                            name: data[i].name,
                            type: 'line',
                            data: data[i].data
                        });
                    }
                    this.series = _series;
                    this.initEchart();
                })
                .catch(() => {});
        },
        // 获取本月收支统计
        getIncomeMain() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/PeriodBusinessStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.incomeMain = data;
                    let reg = new RegExp('-', 'g');
                    if (!this.searchData.sDate && !this.searchData.eDate) {
                        this.incomeMainTitle = '上月数据';
                    } else if (this.searchData.sDate && this.searchData.eDate) {
                        this.incomeMainTitle = `${this.searchData.sDate.replace(reg, '.')} - ${this.searchData.eDate.replace(reg, '.')} 数据`;
                    } else if (this.searchData.sDate && !this.searchData.eDate) {
                        this.incomeMainTitle = `${this.searchData.sDate.replace(reg, '.')} 数据`;
                    } else if (!this.searchData.sDate && this.searchData.eDate) {
                        this.incomeMainTitle = `${this.searchData.eDate.replace(reg, '.')} 数据`;
                    }
                })
                .catch(() => {});
        },
        // 获取总额统计
        getIncomeData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/TotalStatistics',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.incomeData = data;
                })
                .catch(() => {});
        },
        initEchart() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn'));
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '收入支出图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.date
                },
                yAxis: {
                    type: 'value'
                },
                series: this.series
            });
        }
    }
};
</script>
<style lang="less" scoped>
.incomeMainTitle {
    padding: 20px 0 0 15px;
    color: #606266;
}
.data-count {
    padding: 20px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 20px;
            // color: @font3Color;
        }
    }
}
.echart-ctn {
    margin-top: 20px;
    height: 500px;
}
.toggle-year {
    position: absolute;
    top: 279px;
    left: 143px;
}
</style>
